














import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ModalMixin } from '@/mixins/modal.mixin'
import SubmitButton from '@/components/SubmitButton.vue'
import ModalFooter from '@/components/ModalFooter.vue'

@Component({
  components: {
    SubmitButton,
    ModalFooter
  }
})
export default class AssociationsModal extends mixins(ModalMixin) implements ModalMixin {
  apiConfig = {
    path: 'associations'
  }

  form = {
    config: {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 }
    },
    data: null,
    defaults: {
      alias: null
    }
  }
}
